module.exports = __webpack_public_path__ + "static/media/orange.a1cb0411.png";